import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Message } from 'src/app/messages/interfaces/Message';
import { MessageTitle } from 'src/app/messages/interfaces/MessageTitle';
import { MessageDetails } from 'src/app/messages/interfaces/MessageDetails';
import { MessageContent } from 'src/app/messages/interfaces/MessageContent';
import { DomSanitizer } from '@angular/platform-browser';
import 'moment-timezone';
import * as moment from 'moment';
import { GlobalService } from 'src/app/_services/global.service';
import { TimeZoneService } from 'src/app/_services/time-zone.service';
@Component({
  selector: 'app-view-message-list',
  templateUrl: './view-message-list.component.html',
  styleUrls: ['./view-message-list.component.scss']
})
export class ViewMessageListComponent implements OnInit, OnChanges {

  @Input() messagesList: Message[];
  @Input() currentMessage: Message;
  @Output() onScrollList = new EventEmitter<any>();
  @Output() onSortList = new EventEmitter<any>();

  messagesTitles: MessageTitle[]; //send it to (message title component) child
  messageDetails: MessageDetails;
  messageContent: MessageContent;
  safeHTML;

  constructor(private domSanitizer: DomSanitizer , private global:GlobalService , private timeZoneService:TimeZoneService 
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.messagesList) {
      if (changes.messagesList.currentValue != changes.messagesList.previousValue) {
        this.messagesList = this.removeDups(this.messagesList);
        this.messagesTitles = this.messagesList.map(message => (
          {
            title: message.title, id: message.id,
            date: message.updated_at ? message.updated_at.split(' ')[0] : 'No date',
            miniContent: message.content.replace(/(<([^>]+)>)/ig, '').substr(0, 12)
          }
        ));
      }
    }

    if (changes.currentMessage) {
      if (changes.currentMessage.currentValue != changes.currentMessage.previousValue) {

        const currentMessage: Message = changes.currentMessage.currentValue[0];
        let timeFormat = currentMessage?.updated_at
        // const time = timeFormat.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) 
        // const time = moment(timeFormat).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').format('hh:mm A')
        const time = this.timeZoneService.convertToLocalTime(timeFormat , "YYYY-MM-DD HH:mm:ss" , 'hh:mm A')

        const date = currentMessage?.updated_at ? currentMessage.updated_at.split(' ')[0] : 'No data set'
        // const time = currentMessage.updated_at?currentMessage.updated_at.split(' ')[1]: 'No time set'
        this.messageDetails =
        {
          id: currentMessage?.id,
          number_of_views: currentMessage?.number_of_views,
          messageVia: currentMessage?.type,
          recipients: currentMessage?.users,
          time: time,
          date: date,
          title: currentMessage?.title
        }
        this.messageContent = { messageContent: currentMessage?.content, attachments: currentMessage?.attachments }
        this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(this.messageContent.messageContent);
      }
    }

  }
  removeDups(msgs) {
    let splitIndex = -1;
    let unique = [];
    msgs.forEach((msg, index) => {
      const exists = unique.find(item => item.id == msg.id)
      if (!exists) {
        unique.push(msg)
      }
      // else {
      //   if (splitIndex == -1) {
      //     splitIndex = index;
      //   }
      // }

    });
    return unique;
    // return splitIndex == -1 ? msgs : msgs.slice(splitIndex-1);
  }
  onSortTable(event) {
    this.onSortList.emit(event)
  }

  onScroll($event) {
    this.onScrollList.emit($event)
  }

  ngOnInit(): void {

  }

}
